import { logWrapper } from '../../utils';

export default {
  signDocumentD4sService: [
    'runtimeConstant',
    '$http',
    '$q',
    'webApiSettings',
    '$filter',
    function (runtimeConstant, $http, $q, webApiSettings, $filter) {
      'use strict';

      function handleError(status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }
        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SIGNING DOCUMENT'),
        };
      }

      function docD4sSignature(idRevision, listSigners) {
        var deferred = $q.defer();
        var url = 'd4sign/documents/' + idRevision + '/sign';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, listSigners, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function d4sGetSignatories(idRevision) {
        var deferred = $q.defer();
        var url = 'd4sign/documents/' + idRevision;
        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function d4sGetAllSignersSugestion() {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'd4sign/allSigners')
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function updateD4sSignatories(idRevision, listSigners) {
        var deferred = $q.defer();
        var url = 'd4sign/documents/' + idRevision + '/update';
        $http
          .put(webApiSettings.apiServiceBaseUri + url, listSigners, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function docD4sCancel(idRevision) {
        var deferred = $q.defer();
        var url = 'd4sign/document/' + idRevision + '/cancel';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function sendD4SignCredendials(credentials) {
        var deferred = $q.defer();
        var url = 'd4sign/users/credentials';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, credentials, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function downloadD4SignDocument(uuidDocument) {
        var deferred = $q.defer();

        var url = `d4sign/document/${uuidDocument}/download`;

        $http
          .post(webApiSettings.apiServiceBaseUri + url)
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function removeMailD4s(idRevision, mail) {
        var deferred = $q.defer();
        var url = 'd4sign/document/' + idRevision + '/' + mail + '/remove';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function alterMailD4s(idRevision, oldMail, newMail) {
        var deferred = $q.defer();
        var url =
          'd4sign/document/' +
          idRevision +
          '/' +
          oldMail +
          '/' +
          newMail +
          '/change';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function run() {
        try {
          var signDocumentD4sFactory = {};

          signDocumentD4sFactory.d4sGetAllSignersSugestion = logWrapper(
            d4sGetAllSignersSugestion,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.docD4sSignature = logWrapper(
            docD4sSignature,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.d4sGetSignatories = logWrapper(
            d4sGetSignatories,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.updateD4sSignatories = logWrapper(
            updateD4sSignatories,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.docD4sCancel = logWrapper(
            docD4sCancel,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.sendD4SignCredendials = logWrapper(
            sendD4SignCredendials,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.downloadD4SignDocument = logWrapper(
            downloadD4SignDocument,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.removeMailD4s = logWrapper(
            removeMailD4s,
            runtimeConstant.isDebugServicesInternals
          );
          signDocumentD4sFactory.alterMailD4s = logWrapper(
            alterMailD4s,
            runtimeConstant.isDebugServicesInternals
          );

          return signDocumentD4sFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
